module.exports = __webpack_public_path__ + "img/no-result.0da43999.png";